<input matInput (input)="setValue($event)" [placeholder]="placeholder" [disabled]="disabled" [readonly]="readonly"
    [required]="required" [matAutocomplete]="auto" [matAutocompleteDisabled]="!autoComplete">

<mat-autocomplete #auto="matAutocomplete" (optionSelected)="value=$event.option.value">
    <mat-option *ngFor="let option of userPhoneNumberAutocomplete$ | async " [value]="option.phoneNumber">
        {{option.getFullName() +' : '+option.phoneNumber}}
    </mat-option>
</mat-autocomplete>